require("./snippets/scroll-to-hash");
